import { BrandCampaignItemDTO, BrandCampaignPatchItemDTO } from '../dto';
import { BaseCampaignItem, BaseCampaignItemProps } from './BaseCampaignItem';
import { CampaignPrice } from './CampaignPrice';
import { CampaignUser } from './CampaignUser';

interface BrandCampaignItemProps extends BaseCampaignItemProps {
  secondaryDiscountPercentage?: number;
  tertiaryDiscountPercentage?: number;
  updatedAt?: string;
  updatedBy?: CampaignUser;
}

export class BrandCampaignItem extends BaseCampaignItem {
  secondaryDiscountPercentage?: number;
  tertiaryDiscountPercentage?: number;
  updatedAt?: string;
  updatedBy?: CampaignUser;

  constructor(props: BrandCampaignItemProps) {
    super(props);
    this.secondaryDiscountPercentage = props.secondaryDiscountPercentage;
    this.tertiaryDiscountPercentage = props.tertiaryDiscountPercentage;
    this.updatedAt = props.updatedAt;
    this.updatedBy = props.updatedBy;
  }

  override getSalesPriceForCampaignUnit = () =>
    this.campaignSalesUnitPrices?.find((price) => price.unit.unit === this.campaignUnit);

  static fromDto(dto: BrandCampaignItemDTO, locale: string): BrandCampaignItem {
    return new BrandCampaignItem({
      id: dto.id,
      mgItemNumber: dto.mgItemNumber,
      mgSupplierItemId: dto.mgSupplierItemId,
      primaryText: dto.primaryText,
      secondaryText: dto.secondaryText,
      mgSupplierId: dto.mgSupplierId,
      mgSupplierName: dto.mgSupplierName,
      finfoNumber: dto.finfoNumber,
      nobbNumber: dto.nobbNumber,
      groupNumber: dto.groupNumber,
      groupDescription: dto.groupDescription,
      discountGroup: dto.discountGroup,
      primaryPackageUnit: dto.primaryPackageUnit,
      campaignUnit: dto.campaignUnit,
      isSalesPriceOverridable: dto.isSalesPriceOverridable,
      secondaryDiscountPercentage: dto.secondaryDiscountPercentage,
      tertiaryDiscountPercentage: dto.tertiaryDiscountPercentage,
      campaignSalesUnitPrices: CampaignPrice.fromDtoToList(dto.salesPrice, locale),
      campaignPurchaseUnitPrices: dto.purchasePrice
        ? CampaignPrice.fromDtoToList(dto.purchasePrice, locale)
        : undefined,
      purchasePeriodFrom: dto.purchasePeriodFrom,
      purchasePeriodTo: dto.purchasePeriodTo,
      createdAt: dto.createdAt,
      createdBy: dto.createdBy ? CampaignUser.fromDto(dto.createdBy) : undefined,
      updatedAt: dto.updatedAt,
      updatedBy: dto.updatedBy ? CampaignUser.fromDto(dto.updatedBy) : undefined,
    });
  }

  override getPatchCampaignItem = (): BrandCampaignPatchItemDTO => ({
    ...this.getBasePatchCampaignItem(),
    isSalesPriceOverridable: this.isSalesPriceOverridable,
  });
}
